import { OVERLAY_ICON_BUTTON_SIZE } from 'components/Kizen/IconButton';

// Kept apart from AddButton itself so the layout code can size nodes without
// importing the component. AddButton pulls in the automations selectors, and
// through them the app's services and sagas - a graph that reads environment
// variables at module scope and cannot be imported by a plain unit test.
export const ADD_BUTTON_HEIGHT = 36;
export const ADD_BUTTON_WIDTH = OVERLAY_ICON_BUTTON_SIZE;
export const MERGE_HEIGHT = 44;
